import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

export const ProviderFormContainer = ({ children }: React.PropsWithChildren) => {
  return (
    <Container>
      <Row>
        <Col xs={12} md={10} lg={8} className="mx-auto">
          {children}
        </Col>
      </Row>
    </Container>
  );
};
